import axios from "axios";
import { store } from "../store/Store";

const BASEURL = process.env.REACT_APP_UAT_BASE_URL;

const axiosInCar = axios.create({
  baseURL: BASEURL,
});
axiosInCar.interceptors.request.use((config) => {
  const auth = store.getState().cardetail?.carnum;
  // console.log(auth);
  const token = auth?.token;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  return config;
});

export default axiosInCar;
